import { createAction } from "typesafe-actions";
import { Palette } from "./types";

export const addPaletteToGallery = createAction(
  "gallery/ADD_PALETTE_TO_GALLERY"
)<Palette>();
export const removePaletteFromGallery = createAction(
  "gallery/REMOVE_PALETTE_FROM_GALLERY"
)<number>();
